import { z } from 'zod';
/**
 * Frontend environment configuration schema
 * Validates all environment variables used by the frontend
 */
export const FrontendEnvironmentSchema = z.object({
    apiBaseUrl: z.string().url('API base URL must be a valid URL'),
    /** Canonical app origin for tenant path URLs and QR codes (e.g. https://app.cnapse.ai). */
    publicAppUrl: z.string().url('Public app URL must be a valid URL'),
});
//# sourceMappingURL=environment.schema.js.map